export const SET_DATA = 'SET_DATA'
export const SET_TEST_DOCUMENT = 'SET_TEST_DOCUMENT'
export const SET_TEST_DOCUMENT_CONTENT = 'SET_TEST_DOCUMENT_CONTENT'
export const SET_COMPANY_NEWS_LIST = 'SET_COMPANY_NEWS_LIST'
export const SET_COMPANY_NEWS = 'SET_COMPANY_NEWS'
export const SET_LOGS = 'SET_LOGS'
export const SET_FAQ = 'SET_FAQ'
export const SET_PAPER_16 = 'SET_PAPER_16'
export const SET_PAPER_17 = 'SET_PAPER_17'
export const SET_PAPER_18 = 'SET_PAPER_18'
export const SET_PAPER_19 = 'SET_PAPER_19'
export const SET_PAPER_20 = 'SET_PAPER_20'
export const SET_PAPER_21 = 'SET_PAPER_21'
export const SET_PAPER_22 = 'SET_PAPER_22'
export const SET_PAPER_23 = 'SET_PAPER_23'
export const SET_PAPER_24 = 'SET_PAPER_24'
export const SET_FORMAT_CONVERSION = 'SET_FORMAT_CONVERSION'
export const SET_DATA_VISUALIZATION = 'SET_DATA_VISUALIZATION'
export const SET_DATA_POST_PROCESSING = 'SET_DATA_POST_PROCESSING'
export const SET_MODULE = 'SET_MODULE'
export const SET_TEST_LOG = 'SET_TEST_LOG'
